import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isEmailValid } from "../../utils/emailValidation";
import { IUser } from "../../type";
import { webLogin } from "../../api/user";
import { subscribeForPush } from "../../utils/pushSubscription";
import { ensureClientFingerprint, setClientLoginHint } from "../../utils/clientIdentity";

interface IProps {
  onLoginSuccess: (user: IUser) => void;
}

export function Login(props: IProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const sessionExpiredHint = (() => {
    try {
      const params = new URLSearchParams(location.search);
      return params.get("session") === "expired";
    } catch {
      return false;
    }
  })();

  useEffect(() => {
    ensureClientFingerprint();
  }, []);

  const onSubmit = async () => {
    setError("");
    if (!isEmailValid(email)) {
      setError("Пожалуйста, введите корректный e-mail.");
      return;
    }
    if (!password || password.length < 4) {
      setError("Пожалуйста, введите пароль.");
      return;
    }

    setIsLoading(true);
    try {
      setClientLoginHint(email);
      const r = await webLogin({ email, password });
      if (r.type === "success") {
        props.onLoginSuccess(r.user);
        subscribeForPush("web");
        navigate("/");
      } else {
        setError(r.message || "Не удалось выполнить вход");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="section mainPage flex flex-column loginPageAuth">
      <div className="RegistrationConteinerText">
        <div className="textConteiner">
          <h2>Вход</h2>
          <p>Введите email и пароль</p>
          {sessionExpiredHint && !error && (
            <p className="error-message">
              Сессия истекла. Пожалуйста, войдите снова.
            </p>
          )}

          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setClientLoginHint(e.target.value);
              setError("");
            }}
            placeholder="E-mail"
            required
            autoFocus
            onKeyUp={(e) => {
              if (e.code === "Enter") onSubmit();
            }}
          />

          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError("");
            }}
            placeholder="Пароль"
            required
            onKeyUp={(e) => {
              if (e.code === "Enter") onSubmit();
            }}
          />

          {error && <p className="error-message">{error}</p>}
          {isLoading && <p className="error-message">Загрузка...</p>}
        </div>

        <div className="registration-button" onClick={onSubmit}>
          Войти
        </div>

        <div className="loginPageAuth-footerLink">
          Нет аккаунта?{" "}
          <span
            style={{ fontWeight: 700, cursor: "pointer" }}
            onClick={() => navigate("/registration")}
          >
            Зарегистрируйтесь
          </span>
        </div>
      </div>
    </section>
  );
}

